import React from 'react';
import { SvgIcon } from '@mui/material';

const MessageIcon = React.forwardRef((props, ref) => {
	const { sx, ...other } = props;
	
	return (
		<SvgIcon
			ref={ref}
			viewBox="0 0 12 12"
			sx={sx}
			{...other}
		>
			<path 
				d="M2.33333 7H7V6.33333H2.33333V7ZM2.33333 5H9.66667V4.33333H2.33333V5ZM2.33333 3H9.66667V2.33333H2.33333V3ZM0 11.3847V1.07733C0 0.770222 0.102889 0.514 0.308667 0.308667C0.514445 0.103333 0.770444 0.000444444 1.07667 0H10.9233C11.23 0 11.486 0.102889 11.6913 0.308667C11.8967 0.514445 11.9996 0.770667 12 1.07733V8.25667C12 8.56333 11.8971 8.81956 11.6913 9.02533C11.4856 9.23111 11.2296 9.33378 10.9233 9.33333H2.05133L0 11.3847ZM1.76667 8.66667H10.9233C11.0256 8.66667 11.1196 8.624 11.2053 8.53867C11.2911 8.45333 11.3338 8.35933 11.3333 8.25667V1.07667C11.3333 0.974444 11.2907 0.880444 11.2053 0.794667C11.12 0.708889 11.026 0.666222 10.9233 0.666667H1.07667C0.974444 0.666667 0.880444 0.709333 0.794667 0.794667C0.708889 0.88 0.666222 0.974 0.666667 1.07667V9.76333L1.76667 8.66667Z" 
				fill="currentColor"
			/>
		</SvgIcon>
	);
});

MessageIcon.displayName = 'MessageIcon';

export default MessageIcon;
